"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomOutIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ZoomOutIcon = () => {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsxs)("g", { fill: "none", "fill-rule": "evenodd", children: [(0, jsx_runtime_1.jsx)("path", { d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("rect", { fill: "#F7F8FC", x: "6", y: "11", width: "12", height: "2", rx: "1" })] }) }));
};
exports.ZoomOutIcon = ZoomOutIcon;
